import React, { useState, useEffect, useRef } from 'react';
import './ProfileMenu.css';

const ProfileMenu = ({ user, onSignOut, profilePictureUrl = null }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [isOpen]);

  const handleSignOut = () => {
    setIsOpen(false);
    onSignOut();
  };

  // Get user initials from email
  const getInitials = (email) => {
    if (!email) return '?';
    const parts = email.split('@')[0].split('.');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return email[0].toUpperCase();
  };

  return (
    <div className="profile-menu-container" ref={menuRef}>
      <button
        className="profile-menu-button"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-haspopup="true"
        aria-label="User menu"
      >
        <div className="profile-icon-wrapper">
          {profilePictureUrl && !imageError ? (
            <img 
              src={profilePictureUrl} 
              alt={user?.email || 'User'}
              className="profile-picture"
              onError={() => setImageError(true)}
            />
          ) : (
            <span className="profile-initials">{getInitials(user?.email)}</span>
          )}
        </div>
      </button>
      {isOpen && (
        <div className="profile-menu-dropdown">
          <div className="profile-menu-header">
            <div className="profile-menu-email">{user?.email}</div>
          </div>
          <div className="profile-menu-divider"></div>
          <button
            className="profile-menu-item"
            onClick={handleSignOut}
          >
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
};

export default ProfileMenu;
